module.exports = __webpack_public_path__ + "fonts/gothica1-extralight-webfont.219b1e0.woff2";